import Head from 'next/head';

import { UDACITY_ORGANIZATION_DETAILS } from '../utils/organization-data';

export function OrganizationStructuredData() {
  return (
    <Head>
      <script
        key='structured-data-organization'
        dangerouslySetInnerHTML={{ __html: JSON.stringify(UDACITY_ORGANIZATION_DETAILS) }}
        type='application/ld+json'
      />
    </Head>
  );
}
